import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/common";
import { ForcePasswordChange } from "@/components/ForcePasswordChange";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-canvas)]">
        <LoadingState label="Authenticating..." />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user.password_change_required) return <ForcePasswordChange />;
  return children;
}
